module.exports = __webpack_public_path__ + "static/media/LBFL_26-March_Press_8-col-X-5-inch_Output.798c1ed4.jpg";